import { ICON_BUTTON_ICONS } from '../buttons/IconButton';

/**
 * The "Show data sources" toggle (DataSourceToggleIcon) as a `ResultsMobileActionBar`
 * descriptor, for the bar's More sheet on saved projects and Team feedback. Call it inside an
 * observer so the Show / Hide label follows the store.
 */
export const dataSourcesMoreAction = (utilsStore) => ({
  key: 'data-sources',
  label: utilsStore.showDataSources ? 'Hide data sources' : 'Show data sources',
  icon: ICON_BUTTON_ICONS.INFO_CIRCLE,
  onClick: () => utilsStore.setShowDataSources(!utilsStore.showDataSources)
});
